import React from 'react';
import styles from './ServicesCard.module.css';

const ServicesCard = ({
  image,
  title,
  provider,
  rating,
  reviews,
  time,
  location,
  tags,
  price,
  priceUnit,
  onDetails,
  avatar,
  providerIcon
}) => {
  return (
 <div className={styles.serviceCard}>
  <div className={styles.imgWrapper}>
    <img src={image} className={styles.img} alt="service" />
    <div className={styles.icon}>
      <span>{providerIcon}</span>
    </div>
  </div>
  <div className={styles.body}>
    <div className={styles.provider}>
      <img src={avatar} alt={provider} className={styles.avatar} />
      <div>
        <div className={styles.title}>{title}</div>
        <div className={styles.by}>{provider}</div>
      </div>
    </div>
    <div className={styles.meta}>
      <span className={styles.rating}>⭐ {rating} <span>({reviews})</span></span>
      <span className={styles.time}>⏱ {time}</span>
    </div>
    <div className={styles.location}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin w-4 h-4" aria-hidden="true"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path><circle cx="12" cy="10" r="3"></circle></svg> {location}</div>
    <div className={styles.tags}>
      {tags.map(tag => (
        <span key={tag} className={styles.tag}>{tag}</span>
      ))}
    </div>
    <div className={styles.footer}>
      <div className={styles.price}>
        Starting at <span className={styles.highlight}>
           <span className={styles.price}>${price}</span>  
           <span className={styles.system}>{priceUnit}</span> 
            </span>
      </div>
      <button className={styles.detailsBtn} onClick={onDetails}>
        View Details
      </button>
    </div>
  </div>
</div>

  );
};

export default ServicesCard;
